import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alertElementStyles", "children", "closeDelay"],
  _excluded2 = ["itemRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Alert as AlertWrapper, Flex, Text, Tooltip as TooltipComponent } from '@chakra-ui/react';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Tooltip(_ref) {
  var alertElementStyles = _ref.alertElementStyles,
    children = _ref.children,
    _ref$closeDelay = _ref.closeDelay,
    closeDelay = _ref$closeDelay === void 0 ? 0 : _ref$closeDelay,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ = props.itemRef,
    extraProps = _objectWithoutProperties(props, _excluded2);
  return _jsx(TooltipComponent, _objectSpread(_objectSpread({
    closeDelay: closeDelay,
    label: _jsxs(AlertWrapper, _objectSpread(_objectSpread({
      background: "transparent",
      paddingLeft: 0
    }, alertElementStyles), {}, {
      children: [extraProps.svg && _jsx(Icon, {
        svg: extraProps.svg,
        mt: extraProps.title && '-20px'
      }), _jsxs(Flex, {
        direction: "column",
        justifyContent: "space-evenly",
        children: [extraProps.title !== 'undefined' && _jsx(Text, {
          ml: "sm",
          fontWeight: "semibold",
          children: extraProps.title
        }), _jsx(Text, {
          ml: "sm",
          children: extraProps.description
        })]
      })]
    }))
  }, extraProps), {}, {
    children: children
  }));
}